import { ChangeDetectionStrategy, Component, HostBinding, Input, ViewEncapsulation } from '@angular/core';

/**
 * @deprecated Please use the SkeletonGridComponent, SkeletonBlockComponent or SkeletonCardComponent
 */
@Component({
  selector: 'rma-skeleton',
  templateUrl: './skeleton.component.html',
  styleUrls: ['./skeleton.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class SkeletonComponent {
  @Input()
  public bones = 12;

  @Input()
  @HostBinding('class')
  public template: 'single-block' | 'default' | 'avatar' | 'custom' | 'line' = 'default';
}
